import { Link } from "react-router-dom";
import { latestGossip } from "@/mocks/home";

export default function LatestGossipSection() {
  return (
    <section className="px-6 md:px-10 py-14 md:py-18 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        {/* Section header */}
        <div className="flex items-center justify-between mb-10">
          <div>
            <span className="inline-flex items-center px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
              <i className="ri-flashlight-line mr-1.5"></i>
              最新爆料
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              今日黑料速递
            </h2>
          </div>
          <Link
            to="/category/star-gossip"
            className="hidden sm:flex items-center gap-1.5 text-sm font-medium text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Cards Grid - horizontal scroll on mobile */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {latestGossip.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.title} - 黑料网`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {item.isNew && (
                  <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 dark:text-foreground-950 text-xs font-semibold rounded-md">
                    NEW
                  </span>
                )}
              </div>

              {/* Content */}
              <div className="p-4">
                <span className="inline-block text-xs font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded-md mb-2.5">
                  {item.category}
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-950 leading-snug mb-2.5 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views >= 10000 ? `${(item.views / 10000).toFixed(1)}万` : item.views}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Mobile view all */}
        <div className="flex sm:hidden justify-center mt-6">
          <Link
            to="/category/star-gossip"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
          >
            查看全部爆料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}